import { Avatar, Skeleton, SkeletonText } from '@chakra-ui/react';
import { t } from 'i18next';
import { isEmpty, isNull } from 'lodash';
import { isCompletedTrading } from '@pocapan/shared/utils/TradingHelper';
import { openNewTab } from '@pocapan/shared/utils/UIUtils';
import ProfileLineButton from '../buttons/ProfileLineButton';
import VerifiedIcon from '../icons/VerifiedIcon';

export default function TradingPhotoCardInfo({
  tradingPhotoCard,
  showProfile = false,
  showPrice = false,
  halfType = false,
  onSelectPrice
}) {
  const navigatePhotoCardDetailPage = (photoCardId) => {
    const currentPath = window.location.pathname;
    const targetPath = `/photo_cards/${photoCardId}`;

    if (currentPath !== targetPath) {
      // TODO : Please be careful to open newtab infinitely
      openNewTab(targetPath);
    }
  };

  const navigateUserTradingProfile = (userProfile) => {
    const currentPath = window.location.pathname;
    const userProfilePath = `/trading/user_profile/${userProfile?.userProfileId}`;
    if (currentPath === userProfilePath) return;

    if (!isEmpty(userProfile?.userProfileId)) {
      openNewTab(userProfilePath);
    }
  };

  const onSelectedPrice = (price) => {
    if (onSelectPrice) {
      onSelectPrice(price);
    }
  };

  return tradingPhotoCard ? (
    <div className="flex items-center">
      <div className="flex-none">
        <button type="button" onClick={() => navigatePhotoCardDetailPage(tradingPhotoCard.photoCard.photoCardId)}>
          <img
            className="w-[40px] h-[62px] !m-0 rounded-[6px] object-cover"
            src={tradingPhotoCard.photoCard.smallThumbnailUrl || tradingPhotoCard.photoCard.pictureUrl}
            loading="lazy"
            alt=""
          />
        </button>
      </div>
      <div className="grow pl-[10px]">
        <div className="flex flex-col gap-[5px]">
          <p className="text-[14px] leading-[17px] font-medium overflow-hidden line-clamp-1 text-main-light-1 dark:text-main-dark-1">
            {`${tradingPhotoCard.memberName || tradingPhotoCard.photoCard.member?.name}의 ${tradingPhotoCard.photoCard.categoryName}`}
          </p>
          <p className="text-[12px] leading-[14px] font-medium mb-[4px] overflow-hidden line-clamp-1 text-main-light-3 dark:text-main-dark-3">
            {tradingPhotoCard.photoCard.eventName || tradingPhotoCard.photoCard.event?.name}
          </p>
        </div>
      </div>
      {(showProfile || showPrice) && (
        <div className={`flex flex-col items-end ${showProfile && showPrice ? '' : 'self-center'}`}>
          {showProfile && (
            <button
              type="button"
              className="flex-none pl-[6px] max-w-[135px]"
              onClick={() => navigateUserTradingProfile(tradingPhotoCard.userProfile)}
            >
              <ProfileLineButton
                leftIcon={
                  tradingPhotoCard.userProfile.pictureUrl ? (
                    <img
                      src={tradingPhotoCard.userProfile.pictureUrl}
                      className="w-4 h-4 rounded-full object-cover"
                      alt=""
                    />
                  ) : (
                    <Avatar style={{ width: '16px', height: '16px' }} />
                  )
                }
                rightIcon={
                  tradingPhotoCard.userProfile.identified ? (
                    <div className="min-w-[14px]">
                      <VerifiedIcon width={'14px'} height={'14px'} />
                    </div>
                  ) : (
                    <></>
                  )
                }
                text={tradingPhotoCard.userProfile.nickname}
              />
            </button>
          )}
          {showPrice && (
            <p
              className={`text-[17px] font-semibold text-textPrimary-light dark:text-textPrimary-dark ${onSelectPrice && !isCompletedTrading(tradingPhotoCard) ? 'underline cursor-pointer' : ''}`}
              onClick={() => onSelectedPrice(tradingPhotoCard.price)}
            >
              {isNull(tradingPhotoCard.price)
                ? t('tradingPhotoCardPage.offerPriceWithEmoji')
                : tradingPhotoCard.price}
            </p>
          )}
        </div>
      )}
    </div>
  ) : (
    <div className="flex items-start">
      <Skeleton
        width={'40px'}
        height={'62px'}
        startColor="rgba(0, 0, 0, 0.04)"
        endColor="rgba(0, 0, 0, 0.02)"
      />
      <div className="pt-[2px]">
        <SkeletonText
          noOfLines={2}
          width={'75px'}
          startColor="rgba(0, 0, 0, 0.04)"
          endColor="rgba(0, 0, 0, 0.02)"
        />
      </div>
    </div>
  );
}
